import React, { useEffect, useMemo } from "react";
import useSelfpointEffect from "../common3/hooks/useSelfpointEffect";
import DotLoader from "../common3/Loaders/DotLoader";

const Effect = (props) => {
  const { extra = {}, formData, id, save } = props;
  const { watchFormFields = [], persist } = extra;
  const pageSize = 100000;
  const page = 0;

  let watchArray = useMemo(() => {
    // special case for builder
    if (!formData) {
      return [page, pageSize];
    }
    return watchFormFields.reduce(
      (acc, cur) => {
        acc.push(formData[cur]);
        return acc;
      },
      [page, pageSize]
    );
  }, [page, pageSize, formData]);

  const [, effect] = useSelfpointEffect({
    ...props,
    watchArray,
    context: { skip: page, limit: pageSize },
  });

  useEffect(() => {
    if (persist && id && effect) {
      save({ key: id, value: effect });
    }
  }, [effect]);

  if (!effect) {
    return <DotLoader />;
  }

  return null;
};

export default Effect;
